import { createMmWsAction } from '@skynet/data-ws-mm';
import { AdminPanelCommands } from './types';
import type { BindUnbindAccountResult } from './types';

export const bindAccount = createMmWsAction<BindUnbindAccountResult, BindUnbindAccountResult>(
  'adminPanel/bindAccount',
  (data: BindUnbindAccountResult) => ({
    command: AdminPanelCommands.BindAccount,
    ...data,
  }),
);

export const unbindAccount = createMmWsAction<BindUnbindAccountResult, BindUnbindAccountResult>(
  'adminPanel/unbindAccount',
  (data: BindUnbindAccountResult) => ({
    command: AdminPanelCommands.BindAccount,
    ...data,
  }),
);
